// 3rd
import { Model } from '@vuex-orm/core'
// models
import Profile from './Profile';
// utils
import {
    api,
    authHeaders,
    errorHandler
} from '../utils/api';
import {
    LOADER_FETCH_APPROVALS,
    API_ENDPOINT_FETCH_APPROVALS,
    LOADER_APPROVE_PARTICIPANT,
    API_ENDPOINT_POST_APPROVAL_APPROVE,
    LOADER_DECLINE_PARTICIPANT,
    API_ENDPOINT_POST_APPROVAL_DECLINE,
} from '../utils/constants';

export default class ParticipantApproval extends Model {
    static entity = 'participant-approvals';

    static fields() {
        return {
            id: this.attr(null),
            created_at: this.attr(''),
            updated_at: this.attr(''),
            uuid: this.string(''),
            participant_number: this.attr(''),
            first_name: this.string(''),
            last_name: this.string(''),
            terms_and_conditions: this.boolean(false),
            data_protection_agreement: this.boolean(false),
            email: this.string(''),
            email_verified_at: this.string(''),
            company_id: this.attr(''),
            role: this.string(''),
            approved: this.boolean(false),
            declined: this.boolean(false),
            deleted_at: this.attr(null),
            active: this.boolean(false),
            attribute: this.attr(null),
            profile: this.hasOne(Profile, 'user'),
        }
    }

    // api calls
    static async fetch() {
        ParticipantApproval.store().dispatch('wait/start', LOADER_FETCH_APPROVALS);

        const response = await api.get(API_ENDPOINT_FETCH_APPROVALS, authHeaders()).catch(errorHandler);
        if (!response) return;

        const { data } = response;
        const {
            approvals,
            reasons,
        } = data;

        ParticipantApproval.insert({
            data: approvals,
        });

        ParticipantApproval.store().dispatch('wait/end', LOADER_FETCH_APPROVALS);

        return reasons;
    }

    static async approve(approvalId, userId) {
        ParticipantApproval.store().dispatch('wait/start', `${LOADER_APPROVE_PARTICIPANT}${approvalId}`);

        const response = await api.post(API_ENDPOINT_POST_APPROVAL_APPROVE, { user_id: userId }, authHeaders()).catch(errorHandler);
        if (!response) return;

        ParticipantApproval.update({
            where: approvalId,
            data: {
                approved: true,
            }
        });

        ParticipantApproval.store().dispatch('wait/end', `${LOADER_APPROVE_PARTICIPANT}${approvalId}`);
    }

    static async decline(approvalId, userId, reasonId) {
        ParticipantApproval.store().dispatch('wait/start', `${LOADER_DECLINE_PARTICIPANT}${approvalId}`);

        const response = await api.post(API_ENDPOINT_POST_APPROVAL_DECLINE, { reason_id: reasonId, user_id: userId }, authHeaders()).catch(errorHandler);
        if (!response) return;

        ParticipantApproval.update({
            where: approvalId,
            data: {
                declined: true,
            }
        });

        ParticipantApproval.store().dispatch('wait/end', `${LOADER_DECLINE_PARTICIPANT}${approvalId}`);
    }

    // getters
    static getAll() {
        return ParticipantApproval.query().withAll().all();
    }
}
